<template>
  <div class="overflow-hidden">
    <HeaderTwo/>
    <TermsConditionArea/>
    <FooterSeven :dark_bg="true" :dark_btn="true" />
  </div>
</template>

<script>
import HeaderTwo from '../common/Headers/HeaderTwo.vue';
import TermsConditionArea from './terms-condition-area.vue';
import FooterSeven from '../common/Footers/FooterSeven.vue'

export default {
  name:'TermsConditionMain',
  components: { HeaderTwo, TermsConditionArea, FooterSeven },
}
</script>
